import { render } from "./DetalharPeriodoAvaliacao.vue?vue&type=template&id=2fb15f2c&scoped=true"
import script from "./DetalharPeriodoAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharPeriodoAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharPeriodoAvaliacao.vue?vue&type=style&index=0&id=2fb15f2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb15f2c"]])

export default __exports__